import { Env } from "./env.js";
import { Urlparam } from "./urlparam.js"; // URLパラメータ

export class Opening {
  constructor() {
    this.body = {};
    this.html = {};
    this.env = {};
    this.paramAncher = {};
    this.flg = false;
  }

  loaded() {
    this.loadedFlg = true;
  }

  //   startLoader() {
  //     console.log("show-loader");
  //     this.loaderTimeBase = new Date().getTime();
  //     this.timeCheckLoaded();
  //   }

  timeCheckLoaded() {
    let minWaitTime = 0;
    if (this.flg) {
      minWaitTime = 1000;
    }
    //loading完了かつminWaitTimeミリ秒以上経過
    this.timerLoadCheck = setInterval(() => {
      this.loaderTime = new Date().getTime();
      let waitedTime = this.loaderTime - this.loaderTimeBase;
      //console.log("check: loadingWaitedTime=" + waitedTime);

      if (this.loadedFlg && waitedTime > minWaitTime) {
        clearTimeout(this.timerLoadCheck);

        //document.getElementById("index-cover").classList.add("end-loader");

        //console.log('startOp');
        // window.setTimeout(() => {
        //   this.startOpening();
        // }, 600);
        this.body.classList.add("loaded");

        //console.log("loaded, 表示時間=" + waitedTime + "ms, startOpening");
        this.startOpening();
      }
    }, 30);
  }

  showContent() {
    if (document.getElementById("js-content-under-firstview")) {
      document.getElementById("js-content-under-firstview").classList.add("is-show");
    }
  }

  skipOpening() {
    if (document.getElementById("index-cover")) {
      document.getElementById("index-cover").classList.add("show");
      //this.body.classList.add("opening-finished");
      this.body.classList.add("show-menu");
      this.body.classList.add("show-catchcopy");
    }
    if (document.getElementById("common-cover")) {
      this.showContent();
      document.getElementById("common-cover").classList.add("show");
      this.body.classList.add("show-menu");
      this.body.classList.add("show-catchcopy");

      //   this.body.classList.add("opening-finished");
      //   document.getElementById("common-cover").classList.add("opening-finished");
    }
  }

  startOpening() {
    if (document.getElementById("index-cover")) {
      document.getElementById("index-cover").classList.add("show");
      window.setTimeout(() => {
        this.body.classList.add("opening-finished");
        document.getElementById("index-cover").classList.add("opening-finished");
      }, 10);
      window.setTimeout(() => {
        this.body.classList.add("show-menu");
      }, 900);
      window.setTimeout(() => {
        this.body.classList.add("show-catchcopy");
      }, 1600);
    }

    if (document.getElementById("common-cover")) {
      document.getElementById("common-cover").classList.add("show");
      window.setTimeout(() => {
        this.body.classList.add("opening-finished");
        document.getElementById("common-cover").classList.add("opening-finished");
      }, 10);
      window.setTimeout(() => {
        this.showContent();
      }, 100);

      window.setTimeout(() => {
        this.body.classList.add("show-menu");
      }, 900);
      window.setTimeout(() => {
        this.body.classList.add("show-catchcopy");
      }, 1600);
    }
  }

  init() {
    this.body = document.getElementsByTagName("body")[0];
    this.html = document.getElementsByTagName("html")[0];

    // 環境
    this.env = new Env();
    this.env.detectEnv();

    // URLパラメータ
    this.paramAncher = new Urlparam();
    this.paramAncher.getParam("op", location.href);

    // 実行確認
    if (document.getElementById("index-cover") || document.getElementById("common-cover")) {
      this.flg = true;
      if (this.paramAncher.param == 0) {
        this.flg = false;
        this.skipOpening();
      }
    }

    //console.log("show-loader");
    this.loaderTimeBase = new Date().getTime();
    this.timeCheckLoaded();
  }
}
